import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

export interface IAdjustmentOrganization {
	Name: string;
	Organization_ID: number;
	FaultType: string;
}

const initialState = new Array<IAdjustmentOrganization>();

export const { thunk: listAdjustmentOrganizations, slice: listAdjustmentOrganizationsSlice } = getThunkAndSlice<
	Record<string, never>,
	typeof initialState
>({
	initialState,
	path: "/api/Sales/ListAdjustmentOrganizations",
});
